import queryString from 'query-string';
import * as linkify from 'linkifyjs';

import * as envTypes from '../constants/envTypes';
import environment from '../environment';
import { getSessionToken } from './parseSelectors';

/** Return the query params of a search string
 *  If omitted, uses window.location.search
 * @param  {string|undefined} search
 */
export const getQueryParams = (search) => {
  search = search || window.location.search;
  const parsed = queryString.parse(search);

  return parsed;
};
/** Return the value of a query param in the current window.location
 * @param  {string} param
 */
export const getQueryParam = (param) => {
  return getQueryParams()[param];
};

/**
 * Returns true if debugging is on
 */
export const debugOn = () => {
  let debugValue = getQueryParam('debug') || '';
  debugValue = debugValue.toLowerCase();

  return ['1', 'true'].indexOf(debugValue) > -1;
};

export const isProd = () => environment.app.currentEnv === envTypes.PROD;

export const appendHTTPSProtocalIfNeeded = (url) => {
  if (!url) {
    return url;
  }
  const wrongProtocol = 'http://';
  const httpsProtocol = 'https://';
  if (url.indexOf(httpsProtocol) === 0) {
    return url;
  }
  if (url.indexOf(wrongProtocol) === 0) {
    return url.replace(wrongProtocol, httpsProtocol);
  }

  return httpsProtocol + url;
};

export const findUniqueLinks = (messageBody = '') => {
  const links = linkify.find(messageBody).map((linkObject) => linkObject.value);

  return [...new Set(links)];
};

/*
 * Returns hostname from absolute URL.
 * @example http://example.com -> example.com
 * @example //example.com -> example.com
 * @example example.com -> example.com
 * @param {string} link
 */
export const getHostname = (link) => {
  const stringArr = link.split('/');

  if (link.startsWith('http')) {
    stringArr.shift();
  }

  const hostname = stringArr.find((value) => value);

  return hostname;
};

export const isAPIUrl = (url) => {
  return url && url.startsWith(environment.app.serverApiUrl);
};

export const openInNewTab = (url) => {
  const newWindow = window.open(url, '_blank', 'noopener, noreferrer');
  if (newWindow) {
    newWindow.opener = null;
  }
};

export const findAllApiUrlsAndAddSessionToken = (messageBody = '') => {
  if (!messageBody) {
    return messageBody;
  }

  let modifiedMessageBody = messageBody;

  linkify.find(messageBody).forEach((linkObject) => {
    const oldUrl = linkObject.value;

    if (!isAPIUrl(oldUrl)) {
      return;
    }

    const separator = oldUrl.includes('?') ? '&' : '?';

    const newUrl = `${oldUrl}${separator}sessionToken=${getSessionToken()}`;

    modifiedMessageBody = modifiedMessageBody.replace(oldUrl, newUrl);
  });

  return modifiedMessageBody;
};
